// Date picker that presents dd-mm-yyyy to the API but uses the native
// calendar input underneath. value/onChange use 'dd-mm-yyyy' strings.
export default function DateInput({ value, onChange, className = '', disabled = false }) {
  const toNative = (ddmmyyyy) => {
    if (!ddmmyyyy) return '';
    const m = String(ddmmyyyy).match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    return ddmmyyyy;
  };
  const toDdmmyyyy = (native) => {
    if (!native) return '';
    const m = String(native).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    return native;
  };

  return (
    <input
      type="date"
      disabled={disabled}
      className={`input ${className}`}
      value={toNative(value)}
      onChange={(e) => onChange(toDdmmyyyy(e.target.value))}
    />
  );
}